import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";

const guias = [
  {
    slug: "assembly-arm64",
    titulo: "Assembly ARM64",
    descricao: "Mapa do curso — estrutura mínima, memória, stack, aritmética, FPU e controle de fluxo no Raspberry Pi.",
    etapas: "E1–E9",
    cor: "#1ead8a",
  },
  {
    slug: "subagents-claude",
    titulo: "Subagents — Claude Code",
    descricao: "O que são subagents, como criar, projetar e quando usar — guia interativo baseado no material da Anthropic.",
    etapas: "T1–T4",
    cor: "#d97706",
  },
  {
    slug: "motores-robotica",
    titulo: "Motores para Robôs",
    descricao: "Roadmap em 4 etapas: como motores funcionam, PWM, ponte H, servos, motores de passo, brushless e baterias — com demos interativas e quizzes.",
    etapas: "E1–E4",
    cor: "#e06050",
  },
];

function Guias() {
  const navigate = useNavigate();

  return (
    <Container className="mb-5">
      <h1>GUIAS</h1>
      <hr />
      <h3>Guias de Estudo</h3>
      <p>Mapas e referências rápidas para os temas que estou estudando.</p>
      <Row xs={1} md={2} lg={3} className="g-3 mt-2">
        {guias.map((g) => (
          <Col key={g.slug}>
            <Card
              className="h-100 guias-card"
              onClick={() => navigate(`/Guias/${g.slug}`)}
              style={{ borderLeft: `4px solid ${g.cor}` }}
            >
              <Card.Body>
                <Card.Title style={{ fontFamily: "monospace", color: g.cor }}>
                  {g.titulo}
                </Card.Title>
                <Card.Text className="small">{g.descricao}</Card.Text>
              </Card.Body>
              <Card.Footer className="text-muted small">{g.etapas}</Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Guias;
